import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'atomic-router-react';
import { homeRoute, enHomeRoute } from 'src/models/routes';
import { getT } from 'src/i18n';

import './NotFound.scss';

export const NotFound = () => {
  const isEn = window.location.pathname.startsWith('/en');
  const t = getT(isEn ? 'en' : 'ru');

  return (
    <div className="not-found-block">
      <Helmet htmlAttributes={{ lang: isEn ? 'en' : 'ru' }}>
        <title>{t.notFound.title}</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <h1 className="heading">{t.notFound.title}</h1>
      <p className="paragraph not-found-block__text">{t.notFound.text}</p>
      <Link to={isEn ? enHomeRoute : homeRoute} className="not-found-block__link">
        {t.notFound.back}
      </Link>
    </div>
  );
};
